import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { identity } from 'lodash'
import Modal from 'react-modal';
import classNames from 'classnames';

import * as actions from 'ducks/modules/customize'
import PaintSwatch from 'components/PaintSwatch'
import PaintSummary from 'components/PaintSummary'
import PaintFillGrid from 'components/PaintFillGrid'
import { Button } from 'components/Buttons'
import { trackEvent } from '../util/analytics'
import "./PaintColorSwapModal.css"

export class PaintColorSwapModal extends Component {
  constructor(props) {
    super();
    this.state = {
      currentPaintFill: null,
      warning: null,
    };
  }

  setCurrentPaintFill(color) {
    this.setState({
      currentPaintFill: color,
      warning: null,
    });
  }

  setNewPaintFill(color) {
    this.setState({
      newPaintFill: color,
      warning: null,
    });
  }

  setWarning(warning) {
    this.setState({
      warning
    });
  }

  render() {
    const { headerTitle, headerText, colorSelectedText, colorToSelectText, currentPaintFill, replacementPaintFill, paintSummary, allPaintColors, maxPaintfillColors, replacePaint, cancel, className, paintSwapValid } = this.props;
    const eventLabel = (maxPaintfillColors) ? "MaxPaintFillModal:" : "PaintReplaceModal:";
    return (
      <Modal className={classNames("customizer", "modal-popup", className)} overlayClassName="modal-overlay"
        isOpen={!!replacementPaintFill || !!currentPaintFill}
        onAfterOpen = {()=> trackEvent(eventLabel+"Open")}
        contentLabel="Paint Color Swap Modal"
      > 
        <div className="close-modal" onClick={() => { 
          trackEvent(eventLabel+"Cancel");
          cancel();
          if(!!currentPaintFill)
          {
            this.props.checkPaintSwapValid(null, null);
            this.setNewPaintFill(null);
          }
          this.setCurrentPaintFill(null);
        }}>X</div>
        <div className="color-swap-modal-header">{(typeof currentPaintFill !== 'undefined' && currentPaintFill && currentPaintFill.color.id < 0 ? "Select Color" : headerTitle)}</div>
        <p>{headerText}</p>
        <div className="new-replace-color-container">
          <div className="new-color-container">
            <div className="color-selection">
              <div className="new-color">{colorSelectedText}</div>
              <PaintSwatch paint={(!!replacementPaintFill ? replacementPaintFill.color : (currentPaintFill ? currentPaintFill.color : null) )} />
            </div>
          </div>
          <div className="color-replace-container">
            <div className="color-selection">
              <div className="new-color">{colorToSelectText}</div>
              <div>
                {!!paintSummary &&
                  <PaintSummary
                    paints={paintSummary}
                    maxPaintfillColors={maxPaintfillColors}
                    onClick={(paint) => this.setCurrentPaintFill(paint)}
                    selected={(!!this.state && !!this.state.currentPaintFill ? this.state.currentPaintFill : null )}
                  />
                }
                {!!currentPaintFill &&
                  <PaintFillGrid
                    paints={allPaintColors.filter(paintColor => paintColor.onCavityDotsOnly === 'False')}
                    selectedPaint={!!this.state && !!this.state.newPaintFill ? this.state.newPaintFill : null}
                    onSelectPaintFill={(paint) => {this.setNewPaintFill(paint); this.props.checkPaintSwapValid(currentPaintFill.color, paint);}} 
                  />
                }
              </div>
            </div>
          </div>
        </div>
        {typeof paintSwapValid !== 'undefined' && paintSwapValid !== null && !paintSwapValid && 
          <p className="invalid-colors-warning">
            The color you have chosen is not valid in all areas that the current color is selected. If you choose to "REPLACE", the color will be assigned only to areas the color is valid for. Areas that do not allow that color will be de-selected.
          </p>
        }
        {this.state && this.state.warning &&
        <div class="warning-wrapper">
          <div className="no-selection-colors-warning-spacer">&nbsp;</div>
          <div className="no-selection-colors-warning">
            {this.state.warning}
          </div>
        </div>
        }
        <div className="color-replace-buttons">
            <Button onClick={() => {
              trackEvent(eventLabel+"Cancel");
              cancel();
              if(!!currentPaintFill)
              {
                this.props.checkPaintSwapValid(null, null);
                this.setNewPaintFill(null);
              }
              this.setCurrentPaintFill(null);
            }}>Cancel</Button>
            <Button className={(!this.state || (!this.state.newPaintFill && !replacementPaintFill) || (replacementPaintFill && !this.state.currentPaintFill)) ? 'disabled' : '' }
              onClick={() => {
              if(!this.state || (!this.state.newPaintFill && !replacementPaintFill) || (replacementPaintFill && !this.state.currentPaintFill))
              {
                if(replacementPaintFill)
                  this.setWarning('Please select a color to replace.');
                else
                  this.setWarning('Please select a new color.');
                return;
              }
              replacePaint(
                (!!replacementPaintFill ? this.state.currentPaintFill.id : currentPaintFill.color.id),
                (!!replacementPaintFill ? replacementPaintFill.color.id : this.state.newPaintFill.id),
                (!!replacementPaintFill ? replacementPaintFill.location : null ));

              trackEvent(eventLabel+"Replace");
              cancel();
              this.setCurrentPaintFill(null);
              if(!!currentPaintFill)
              {
                this.props.checkPaintSwapValid(null, null);
                this.setNewPaintFill(null);
              }
            }}>{(typeof currentPaintFill !== 'undefined' && currentPaintFill && currentPaintFill.color.id < 0 ? "Select" : "Replace")}</Button>
          </div>
      </Modal>
    )
  }
}

PaintColorSwapModal.propTypes = {
  paints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired, 
  })),
  maxPaintfillColors: PropTypes.number,
  onClick: PropTypes.func, 
  checkPaintSwapValid: PropTypes.func,
}


PaintColorSwapModal.defaultProps = {
  checkPaintSwapValid: identity,
};

const mapStateToProps = (state, ownProps) => {
  return { 
  }
}

const mapDispatchToProps = {
  checkPaintSwapValid: actions.checkPaintSwapValid,
}

export default connect(mapStateToProps, mapDispatchToProps)(PaintColorSwapModal);